module.exports = __webpack_public_path__ + "img/success-filled@2x.da207640.png";